import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginScreen from './components/LoginScreen';
import Dashboard from './components/Dashboard';
import PrivacyPolicy from './components/PrivacyPolicy';
import Support from './components/Support';
import './App.css';
import versionInfo from './version.json';

const AppContent = () => {
  const { isAuthenticated, isLoading, user, isPendingRegistration } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Enhanced debug logging

  // Version checking DISABLED to prevent loops
  React.useEffect(() => {
    const currentVersion = versionInfo.version;

    // Just set the version without any reloading
    localStorage.setItem('appVersion', currentVersion);
  }, []);

  React.useEffect(() => {
    // Auth state changed
  }, [isAuthenticated, isLoading, user, isPendingRegistration]);


  // Show loading only if we're actually loading and NOT in pending registration state
  if (isLoading && !isPendingRegistration) {
    return (
      <div className="app-loading">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (isAuthenticated) {
    try {
      return (
        <Routes>
          <Route path="/home" element={<Dashboard initialTab="home" />} />
          <Route path="/children" element={<Dashboard initialTab="children" />} />
          <Route path="/children/:childUuid/activities" element={<Dashboard initialTab="children" />} />
          <Route path="/children/:childUuid/activities/:activityUuid" element={<Dashboard initialTab="children" />} />
          <Route path="/activity/:childUuid/:activityUuid" element={<Dashboard initialTab="activity" />} />
          <Route path="/calendar" element={<Dashboard initialTab="calendar" />} />
          <Route path="/clubs" element={<Dashboard initialTab="clubs" />} />
          <Route path="/connections" element={<Dashboard initialTab="connections" />} />
          <Route path="/profile" element={<Dashboard initialTab="profile" />} />
          <Route path="/admin" element={<Dashboard initialTab="admin" />} />
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Routes>
      );
    } catch (error) {
      console.error('Error rendering authenticated content:', error);
      return (
        <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
          <h1>❌ Error Loading Dashboard</h1>
          <p>Error: {String(error)}</p>
          <button onClick={() => window.location.reload()}>Reload Page</button>
        </div>
      );
    }
  }

  return <LoginScreen />;
};

// Public routes that don't require authentication
const PublicRoutes = () => {
  const location = useLocation();

  // Check if current path is a public route
  if (location.pathname === '/privacy') {
    return <PrivacyPolicy />;
  }
  if (location.pathname === '/support') {
    return <Support />;
  }

  return null;
};

function App() {
  return (
    <div className="App" data-deployment-pipeline="configured">
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/*" element={<AppContent />} />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;